/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Norwegian (Bokmål)
export default {
  'people.menu.renotify.flag.description': 'Vi sender alle en påminnelse på e-post. Dette kan ta opptil et minutt.',
  'people.menu.renotify.flag.description.confluence': 'Påminn teammedlemmer',
  'people.menu.renotify.flag.title': 'Sender påminnelser',
  'people.menu.renotify.flag.title.confluence': 'Sender e-postinvitasjonen på nytt',
  'people.menu.renotify.menu.description':
    '{userCount, plural, one {{userCount,number} person har ikke godtatt {product}-invitasjonen. Se hvem som mangler, og send hen en påminnelse.} other {{userCount,number} personer har ikke godtatt {product}-invitasjonen. Se hvem som mangler, og send dem en påminnelse.}}',
  'people.menu.renotify.menu.description.confluence':
    'Noen personer har ikke godtatt Confluence-invitasjonen. Se hvem som mangler og send dem en påminnelse.',
  'people.menu.renotify.menu.dismiss': 'Avvis',
  'people.menu.renotify.menu.dismiss.confluence': 'Ikke nå',
  'people.menu.renotify.menu.remind': 'Påminn teammedlemmene',
  'people.menu.renotify.menu.remind.confluence': 'Påminn teammedlemmer',
  'people.menu.renotify.menu.title': 'Er alle med på notene?',
  'people.menu.renotify.modal.copied': 'Koblingen er kopiert',
  'people.menu.renotify.modal.copy': 'Kopier invitasjonskobling',
  'people.menu.renotify.modal.description':
    'Vi kan sende en påminnelse via e-post til de manglende medlemmene, eller du kan dele invitasjonskoblingen selv.',
  'people.menu.renotify.modal.description.confluence':
    'Send e-postinvitasjonen på nytt, eller kopier og del invitasjonskoblingen.',
  'people.menu.renotify.modal.dismiss': 'Avbryt',
  'people.menu.renotify.modal.resend': 'Send påminnelse',
  'people.menu.renotify.modal.resend.confluence': 'Send invitasjon på nytt',
  'people.menu.renotify.modal.title': 'Påminn manglende medlemmer',
  'people.menu.renotify.modal.title.confluence': 'Påminn manglende teammedlemmer',
  'ptc.pm.collaborators.title': 'Dine samarbeidspartnere',
  'ptc.pm.error-heading': 'Noe har gått galt',
  'ptc.pm.error-image-alt-text': 'En ødelagt robot og en rekke mennesker som er opptatt med å fikse den.',
  'ptc.pm.error-text':
    'Vi følger med på disse feilene, men kontakt oss gjerne dersom det å oppdatere siden ikke løser problemet',
  'ptc.pm.num-members':
    '{memberCount, plural, one {{memberCount,number} medlem} other {{memberCount,number} medlemmer}}',
  'ptc.pm.people': 'Personer',
  'ptc.pm.teams': 'Team',
  'ptc.pm.view-your-profile': 'Se din profil',
  'ptc.pm.your-teams.title': 'Teamene dine',
};
